<div
  id="banner"
  class="opt-in-banner"
  *ngIf="displayOptInBanner"
  [ngClass]="isOffersPage ? 'round' : ''"
>
  <div class="opt-in-container">
    <div class="image-container">
      <img src="assets/icons/snackbar-info.png" alt="" class="image" />
    </div>
    <div class="banner-content">
      <div class="banner-text-container">
        <p class="banner-text">
          {{ customerPortalDisclosureText }}
        </p>
        <button
          class="disclosure-btn gordita-400 block desktop-only"
          (click)="disclosureClick()"
        >
          Credit profile authorization
        </button>
      </div>
      <div class="btn-container">
        <button
          id="agree-button"
          class="opt-in-agree-btn mobile-agree-btn"
          (click)="closeOptInBanner(true)"
        >
          Agree
        </button>
        <button
          class="disclosure-btn gordita-400 block mobile-only"
          (click)="disclosureClick()"
        >
          Credit profile authorization
        </button>
      </div>
    </div>
  </div>
  <button
    class="close-btn"
    id="close-button"
    aria-label="Close"
    (click)="closeOptInBanner(false)"
    *ngIf="!isOffersPage"
  >
    <app-icon-close color="#000" width="24" height="24"></app-icon-close>
  </button>
</div>
